export default __webpack_public_path__ + "static/media/react.bd4eec02.png";